import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = { class: "w-100 text-right" }
const _hoisted_10 = { class: "dropup float-left" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "dropdown-menu" }
const _hoisted_13 = { class: "btn-group" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlternativeEditor = _resolveComponent("AlternativeEditor")!

  return (_ctx.opened === true)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.title), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.rm)
                  ? (_openBlock(), _createBlock(_component_AlternativeEditor, {
                      key: 0,
                      propRm: _ctx.rm,
                      propErrors: _ctx.errors,
                      propFormId: "alternativeEditorForm",
                      onFormSubmit: _ctx.save
                    }, null, 8 /* PROPS */, ["propRm", "propErrors", "onFormSubmit"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_ctx.isDeleteVisible)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          disabled: _ctx.operationInProgress === true,
                          type: "button",
                          class: "btn btn-danger",
                          "data-toggle": "dropdown"
                        }, _toDisplayString(_ctx.deleteButtonLabel), 9 /* TEXT, PROPS */, _hoisted_11))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[3] || (_cache[3] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary"
                        }, "Cancel", -1 /* CACHED */)),
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDeleteAlternativeCommand && _ctx.handleDeleteAlternativeCommand(...args))),
                          type: "button",
                          class: "btn btn-danger"
                        }, "Confirm")
                      ])
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    form: "alternativeEditorForm",
                    class: "btn btn-primary",
                    disabled: _ctx.operationInProgress === true
                  }, _toDisplayString(_ctx.saveButtonLabel), 9 /* TEXT, PROPS */, _hoisted_14),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                    class: "btn btn-outline-secondary"
                  }, "Cancel")
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}